<template>
<div class="search">
  <div class="order">
    <div class="head">
      <div class="items">
        <div class="ite">
          <div class="ite-left">系统唯一序号:</div>
          <div class="ite-right">{{ row.guid || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送类型:</div>
          <div class="ite-right">{{ appTypeObj[row.appType] || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送时间:</div>
          <div class="ite-right">{{ row.appTime || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送状态:</div>
          <div class="ite-right">{{ appStatusObj[row.appStatus] || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">申报地海关代码:</div>
          <div class="ite-right">{{ row.customsCode || '--' }}</div>
        </div>
        <div class="ite">
          <div class="ite-left">企业唯一编号:</div>
          <div class="ite-right">{{ row.copNo || '--' }}</div>
        </div>
        <div class="ite">
          <div class="ite-left">电子口岸编号:</div>
          <div class="ite-right">{{ row.preNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">申报企业代码:</div>
          <div class="ite-right">{{ row.agentCode || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">申报企业名称:</div>
          <div class="ite-right">{{ row.agentName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">监管场所代码:</div>
          <div class="ite-right">{{  row.loctNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">运输方式:</div>
          <div class="ite-right">{{ row.trafMode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">运输方式工具名称:</div>
          <div class="ite-right">{{ row.trafName || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">航班班次号:</div>
          <div class="ite-right">{{ row.voyageNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">境内运输工具编号:</div>
          <div class="ite-right">{{ row.domesticTrafNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">毛重（公斤）:</div>
          <div class="ite-right">{{ row.grossWeight || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">物流企业代码:</div>
          <div class="ite-right">{{ row.logisticsCode || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">物流企业名称:</div>
          <div class="ite-right">{{ row.logisticsName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报文总数:</div>
          <div class="ite-right">{{ row.msgCount || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报文序号:</div>
          <div class="ite-right">{{ row.msgSeqNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">备注:</div>
          <div class="ite-right">{{ row.note || '--'}}</div>
        </div>
      </div>
    </div>
  <div>
  </div>
  </div>
  <div class="ux-filter-records filter-records">
            <div class='content-list' style="height:auto">
              <el-table
                empty-text="暂无数据"
                class="table ux-dark-el-table"
                :data="tableData"
                max-height="365"
                element-loading-spinner="el-icon-loading">
                <el-table-column width='80' type='index' label='序号' align='center'>
                  </el-table-column>
                  <el-table-column v-for="(props, i) in tableHeader" :label='props.label' align="left" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="text">{{ scope.row[props.prop] || '--' }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ page.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total"
                @current-change="currentChange"
              />
              <pagination @currentChange="currentChange" @sizeChange="sizeChange"/>
            </div>
          </div>
</div>
</template>
<script>
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
const {mapState} = require('vuex')
export default {
  components: {pagination},
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    appTypeObj: {
      type: Object,
      default: () => {}
    },
    appStatusObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tableData: [],
      tableHeader: [
        {
          label: '总包号',
          prop: 'totalPackageNo'
        },
        {
          label: '物流运单编号',
          prop: 'logisticsNo'
        },
        {
          label: '物流运单编号',
          prop: 'logisticsNo'
        },
        {
          label: '备注',
          prop: 'note'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      }
    })
  },
  methods: {
    currentChange (e) {
      this.page.current = e
      this.getList()
    },
    sizeChange (e) {
      this.page.current = 1
      this.page.size = e
      this.getList()
    },
    getList () {
      let data = {
        'pageNum': this.page.current,
        'pageSize': this.page.size,
        copNo: this.row.copNo,
        customerNo: this.row.info.customerNo
      }
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.bg.tabs.getDeclarationClearanceTotalItem}`,
        data: data
      }).then(res => {
        if (res.data) {
          const dataInfo = res.data || {}
          let getList = dataInfo.records || []
          this.tableData = getList
          this.page.total = dataInfo.total || 0
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.order {
  width: calc(100% - 40px);
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid rgba(37, 92, 152, 1);
  .head {
    padding: 28px 28px 0px;
    .items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      .ite {
        display: flex;
        width: 25%;
        .ite-left {
          width: 50%;
          text-align: right;
        }
        .ite-right {
          width: 50%;
          text-align: left;
          margin-left: 5px;
        }
      }
    }
  }
}

</style>
<style lang="scss">
.ux-filter-records {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 35px 0px 0px;
    box-sizing: border-box;
    .filter {
      display: flex;
      flex-wrap: wrap;
      // div {
      //   margin-right: 18px;
      //   margin-bottom: 10px;
      // }
      .search {
        color: #ffffff;
        background: #1c8be2;
      }
    }
    .content-list {
      margin-top: 10px;
      flex: none;
      // min-height: 550px;
      .table {
        height: 100%;
        .el-table__header-wrapper {
          tr {
            th {
              height: 50px;
            }
          }
        }
        .el-table__body-wrapper {
          tr {
            td {
              height: 50px;
            }
          }
        }
        .el-loading-mask {
          /* background: rgba(0, 0, 0, 0.8); */
          .el-loading-spinner {
            font-size: 24px;
          }
        }
        .text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .ux-dark-el-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #2d6bab;
        background-color: transparent;
        table {
        thead {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color:#fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        }
        td.el-table__cell{
          border-bottom: 1px solid #2d6bab;
        }
        &::before {
          display: none;
        }
        // tbody row hover
        &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
          background: rgba(24, 127, 215, 0.2);
        }
        // 多级表头
        &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
          content: unset;
        }
        .el-table__body-wrapper {
          flex: 1 1;
          table {
            height: 100%;
          }
        }
        .el-table__footer-wrapper tbody td.el-table__cell {
          font-size: 16px;
          background-color: transparent;
        }
      }
    }
    .pages {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
  }</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/components/ListTotal.vue